export default __webpack_public_path__ + "static/media/hht1_ep01_timeline_q04_b.10eb0bfc.png";